import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { LIST_HISTORY } from './constants';
import {
  ListHistorySuccess,
  ListHistoryError,
  ListHistoryDataActionTypes,
  ListHistoryState,
} from './types';

const initialState: ListHistoryState = {
  status: idle,
  entities: [],
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: ListHistoryDataActionTypes,
  ): ListHistoryState => {
    switch (action.type) {
      case LIST_HISTORY + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case LIST_HISTORY + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as ListHistorySuccess).payload.items;
        break;
      }
      case LIST_HISTORY + FAILURE: {
        draft.status = rejected;
        draft.error = (action as ListHistoryError).error;
        break;
      }
      default:
        return draft;
    }
  },
);
